<form class="m-h-12 m-v-8"
  [formGroup]="form">
  <h3>{{ 'sigt.integration.rechercheGdf.form.recherche.titreCritereRecherche' | translate }}</h3>

  <mat-form-field class="d-flex tour-interactif-step-2-step-0">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.dossierTerrainGdf.numeroDossier' | translate }}</mat-label>
    <input formControlName="numeroDossier"
      matInput
      class="form-control"
      maxlength="6"
      placeholder="999999">
    <mat-error *ngIf="form.controls.numeroDossier.errors?.required">
      {{messageApplication.obligatoireNumeroDossier}}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-2-step-1">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.dossierTerrainGdf.annee' | translate }}</mat-label>
    <input formControlName="annee"
      matInput
      class="form-control"
      maxlength="2"
      placeholder="99">
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-2-step-2">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.dossierTerrainGdf.section' | translate }}</mat-label>
    <input formControlName="section"
      matInput
      class="form-control"
      maxlength="3"
      placeholder="999">
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-2-step-3">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.dossierTerrainGdf.statut' | translate }}</mat-label>
    <mat-select formControlName="statut"
      multiple>
      <mat-option *ngFor="let statutsDossier of listStatutsDossiers "
        [value]="statutsDossier.codeStatut">
        {{statutsDossier.nomStatut}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="boutons-en-grille">
    <button mat-raised-button
      type="button"
      class="clear-search-button tour-interactif-gdf-reinitialiser"
      (click)="initialiserChamps()">
      {{ 'sigt.global.boutons.reinitialiser' | translate }}
    </button>

    <button mat-raised-button
      class="search-button tour-interactif-gdf-rechercher"
      [disabled]="!form.valid"
      (click)="rechercher()"
      color="primary">
      {{ 'sigt.global.boutons.rechercher' | translate }}
    </button>
  </div>
</form>